import React from 'react';
import logo from '../../../assets/wilma_care_welcome_logo.svg';
import { PURCHASE_SESSION_STEPS, PurchaseSessionStep } from '../../../constants/purchaseSession';
import Typography from './Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface IPurchaseSessionStepsHeader {
  style?: React.CSSProperties;
  selectedStep: PurchaseSessionStep;
}

export default function PurchaseSessionStepsHeader({
  style,
  selectedStep,
}: IPurchaseSessionStepsHeader) {
  
  return (
    <div className='flex w-full h-auto items-center'>
      <img src={logo} alt='Wilmacare' className="w-1/2 min-w-[200px] sm:w-1/2 md:w-1/3 lg:w-1/4 h-auto"/>
      <div className='flex gap-8 flex-1 ml-32'>
        {
          Object.keys(PURCHASE_SESSION_STEPS).map((step, idx) => (
            <React.Fragment key={idx}>
              <Typography
                style={{fontWeight: selectedStep === step ? 700 : 500}}>
                {PURCHASE_SESSION_STEPS[step as PurchaseSessionStep]}
              </Typography>
              {
                idx !== Object.keys(PURCHASE_SESSION_STEPS).length - 1 && (
                  <ChevronRightIcon />
                )
              }
            </React.Fragment>
          ))
        }
      </div>
    </div>
  )
}